(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-track-order"]) return;
  try {
    
  if (!customElements.get('pixo-order-tracker')) {
    customElements.define('pixo-order-tracker', class extends HTMLElement {
      connectedCallback() {
        if (this.trackingInitialized) return;
        const form = this.querySelector('[data-tracking-form]');
        const fields = this.querySelector('[data-tracking-fields]');
        const input = this.querySelector('[data-tracking-input]');
        const error = this.querySelector('[data-tracking-error]');
        if (!form || !fields || !input || !error) return;

        const clearError = () => {
          input.removeAttribute('aria-invalid');
          error.textContent = '';
          error.hidden = true;
        };
        const showError = message => {
          input.setAttribute('aria-invalid', 'true');
          error.textContent = message;
          error.hidden = false;
          input.focus();
        };

        form.addEventListener('submit', event => {
          event.preventDefault();
          const number = input.value.trim();
          clearError();
          if (!number) {
            showError(this.dataset.errorEmpty);
            return;
          }
          if (number.startsWith('#')) {
            showError(this.dataset.errorOrder);
            return;
          }
          if (number.length > 128 || /[\s\p{C}]/u.test(number)) {
            showError(this.dataset.errorInvalid);
            return;
          }
          const destination = new URL('https://www.17track.net/en/track');
          destination.hash = 'nums=' + encodeURIComponent(number);
          window.location.assign(destination.href);
        });
        input.addEventListener('input', clearError);
        fields.disabled = false;
        this.trackingInitialized = true;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
